"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useCleanableMounting = useCleanableMounting;
exports.withCleanableMounting = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var noProps = {};

function useCleanableMounting(_ref) {
  var _ref$onMountFuncs = _ref.onMountFuncs,
      onMountFuncs = _ref$onMountFuncs === void 0 ? [] : _ref$onMountFuncs,
      _ref$onUnmountFuncs = _ref.onUnmountFuncs,
      onUnmountFuncs = _ref$onUnmountFuncs === void 0 ? [] : _ref$onUnmountFuncs;
  (0, _react.useEffect)(function () {
    return _utils.functionInvocator.apply(void 0, (0, _toConsumableArray2.default)(onMountFuncs.map(function (func) {
      return func();
    })).concat((0, _toConsumableArray2.default)(onUnmountFuncs)));
  }, [onMountFuncs, onUnmountFuncs]);
}

var withCleanableMounting = function withCleanableMounting(_ref2) {
  var _ref2$props = _ref2.props,
      props = _ref2$props === void 0 ? noProps : _ref2$props,
      _ref2$onMountFuncs = _ref2.onMountFuncs,
      onMountFuncs = _ref2$onMountFuncs === void 0 ? [] : _ref2$onMountFuncs,
      _ref2$onUnmountFuncs = _ref2.onUnmountFuncs,
      onUnmountFuncs = _ref2$onUnmountFuncs === void 0 ? [] : _ref2$onUnmountFuncs;
  return function (Component) {
    return function (compProps) {
      useCleanableMounting({
        onMountFuncs: onMountFuncs,
        onUnmountFuncs: onUnmountFuncs
      });
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, compProps, props));
    };
  };
};

exports.withCleanableMounting = withCleanableMounting;